'use strict';

module.exports = {
    host: 'https://delivery2.theomnicore.com/v1',
    defaultLanguage: 'ru',
    languageMap: {
        'uk': 'uk',
        'ua-UA': 'uk',
        'uk-UA': 'uk',
        'ua': 'uk',
        'ru': 'ru',
        'ru-Ru': 'ru',
        'ru-RU': 'ru'
    },
    languageList: ['uk', 'ru']
};